// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8538bc45","453":"8e104b82","667":"d9f6d14b","977":"fe94a6ec"}[chunkId] + ".chunk.js";
};